import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'loading-spinner',
  imports: [MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loading) {
      <div class="flex items-center justify-center mt-10">
        <mat-spinner [diameter]="spinnerHeight" />
        <div class="text-red text-[14px] ml-10">Loading...</div>
      </div>
    }
  `
})
export class LoadingSpinnerComponent {
  @Input() loading = true;
  @Input() spinnerHeight = 40;
}
